import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { ForgotService } from '../shared/Forgot.Service';
import { AppInsightsService } from '../shared/AppInsights.Service';

@Component({
  selector: 'app-identity-mgt-epac',
  templateUrl: './identity-mgt-epac.component.html',
  styleUrls: ['./identity-mgt-epac.component.scss']
})
export class IdentityMgtEpacComponent implements OnInit {
  public type = '';
  public selected = '';
  public planId = '';
  public uid = '';
  public pasteData = '';
  public pasteInd = 'N';
  public userId: string;
  public pwd: string;
  public email: string;
  error: boolean;
  message: any;
  public resp: any;
  public showId = false;
  public showpwd = false;
  public forgot: any;
  public showPlaceholder: boolean;
  public isLoading = false;
  public validate = true;
  public errorFields: any = {
    uid: false,
    planId: false
  };
  constructor(private router: Router,private forgotService: ForgotService, private appInsightsService: AppInsightsService) {}
  
  @ViewChild('user') public user: ElementRef;
  @ViewChild('plan') public plan: ElementRef;
  
  focusOnInput() {
    let setError = false;
    if (!!this.errorFields.uid) {
      setError = true;
      setTimeout(() => this.user.nativeElement.focus(), 0);
      setTimeout(() => this.user.nativeElement.select(), 0);
      window.scrollTo(0,this.user.nativeElement.getBoundingClientRect().top + window.scrollY - 150);
    } else if (!!this.errorFields.planId) {
      setError = true;
      setTimeout(() => this.plan.nativeElement.focus(), 0);
      setTimeout(() => this.plan.nativeElement.select(), 0);
      window.scrollTo(0,this.plan.nativeElement.getBoundingClientRect().top + window.scrollY - 150);
    }
    return setError;
  }

  isErrorPresent() {
    if (!this.errorFields.uid && this.errorFields.planId) {
      return false;
    } else {
      return true;
    }
  }

  validateAllFields() {
    const fields = ['uid', 'planId'];
    let isErrPresent = false;
    for (let j = 0; j < fields.length; j++) {
      isErrPresent = this.validateFields(fields[j]);
      if (isErrPresent) {
        break;
      }
    }
    return isErrPresent;
  }

  ifAtleastOneFieldValidated(model) {
    this.validate = !!this[model] ? false : true;
    return this.validate;
  }
  
  validateFields(model) {
    let error = false;
    this.validate = true;
    if (model === 'uid') {
      if (!this.uid) {
        this.errorFields.uid = true;
        error = true;
      } else {
        this.errorFields.uid = false;
        this.ifAtleastOneFieldValidated(model);
      }
    }
   if (model === 'planId') {
    if (!this.planId) {
      this.errorFields.planId = true;
      error = true;
    } else {
      this.errorFields.planId = false;
      this.ifAtleastOneFieldValidated(model);
    }
   }

    if (!!this.uid && !!this.planId && !this.isErrorPresent() && !error) {
      this.validate = error;
    }
    return error;
  }
  
  ngOnInit() {
    console.log('epac loaded');
    window.scroll(0,0);
    this.showPlaceholder = true;
    this.appInsightsService.logEvent("Forgot UI Page - EPAC");
    this.forgotService.getUid().subscribe( res => {
      this.userId = res;
      if (this.userId) {
        this.showId = true;
      }
    });
    this.forgotService.getType().subscribe( res => {
      this.pwd = res;
      if (this.pwd === 'pwd') {
        this.showpwd = true;
      }
    });
  }
  
  setPlaceholder(ele) {
    if (this.showPlaceholder) {
      ele.setAttribute('placeholder', ele.getAttribute('data-placeholder'));
    } else {
      ele.setAttribute('placeholder', '');
    }
  }
  
  togglePlaceholder(event: FocusEvent) {
    this.showPlaceholder = !this.showPlaceholder;
    this.setPlaceholder(event.target);
  }
  
  numberOnly(event) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode !== 8 && !pattern.test(inputChar)) {
      return event.preventDefault();
    }
    return true;
  }

  continue() {
    if (!this.validateAllFields()) {
      const userType = 'epac';
      const userId = this.uid;
      const planId = this.planId;
      const json = JSON.stringify({ userId, planId , userType});
      console.log(json);
      setTimeout(() => {
      	window.scroll(0,0);
        this.error = false;
        this.isLoading = true;
        this.validate = true;
      });
      this.forgotService.getPassword(json).subscribe( res => {
          this.forgot =  res;
          if (this.forgot) {         
            if (this.forgot.status_code && this.forgot.status_code !== '200') {
                setTimeout(() => {
	              this.isLoading = false;
	            });
                this.message = this.forgot.message;
                this.error = true;
                this.validate = false;
                window.scroll(0,0);
              } else {
                  this.error = false;
                  this.forgotService.setQuestions(this.getQuestions(this.forgot.questions));
                  this.forgotService.setType('pwd');
                  this.forgotService.setUserType(userType);
                  this.router.navigate(['/questions']);
              }
          }
      });
    } else {
    	this.focusOnInput();
    }
  }
  
  getQuestions(questions){
  	let questArr = [];
  	let index = [];
  	for (let k=0; k < questions.length; k++) {
  		if (questions[k] !== '' && questions[k] !== null) {
  			index.push(k);
  			questArr.push(questions[k]);
  		} else {
  			index.push(null);
  		}
  	}
  	this.forgotService.setQuesIndex(index);
  	return questArr;
  }

  back() {
    this.router.navigate(['']);
  }

  paste(event: ClipboardEvent) {
    if (event && event.clipboardData) {
      this.pasteData = event.clipboardData.getData('text');
    }
  }
}
